// AccountToggles.js
import React, { useEffect, useState } from "react";
import { Box, Typography, Switch, Paper, Divider } from "@mui/material";
import SecureLS from "secure-ls";
import axios from "axios";
import Swal from "sweetalert2";
import AccountHero from "./AccountHero";
import TitleSetter from "../../component/TitleSetter";
import toggleDescriptions from "./AccToggleDesc";
import AccToggleUI from "./AccToggleUI";

const ls = new SecureLS({ encodingType: "aes" });

const AccountToggles = () => {
  const authToken = ls.get("authToken");
  const [toggles, setToggles] = useState({});

  const fetchToggles = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/api/pos/toggles`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (res.data) setToggles(res.data);
    } catch (error) {
      console.error("Failed to fetch toggles:", error);
    }
  };

  const handleToggle = async (toggleName) => {
    const currentValue = toggles[toggleName];
    const turningOn = !currentValue;

    const confirm = await Swal.fire({
      title: `Toggle ${formatLabel(toggleName)}?`,
      text: `Are you sure you want to turn ${
        turningOn ? "on" : "off"
      } the "${formatLabel(toggleName)}" feature?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `Yes, turn ${turningOn ? "ON" : "OFF"}`,
      cancelButtonText: "Cancel",
    });

    if (!confirm.isConfirmed) return;

    try {
      const endpoint = toggleName.replaceAll(" ", "-");
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/api/pos/toggle-${endpoint}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (res.data?.[toggleName] !== undefined) {
        setToggles((prev) => ({
          ...prev,
          [toggleName]: res.data[toggleName],
        }));

        Swal.fire({
          icon: "success",
          title: `Toggled ${formatLabel(toggleName)}`,
          text: `${formatLabel(toggleName)} is now ${
            res.data[toggleName] ? "ON" : "OFF"
          }.`,
        });
      }
    } catch (error) {
      console.error(`Failed to toggle ${toggleName}:`, error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: `Failed to toggle ${formatLabel(toggleName)}.`,
      });
    }
  };

  const formatLabel = (str) =>
    str
      .split(" ")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

  useEffect(() => {
    fetchToggles();
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <TitleSetter title="Account Toggles" />
      <AccountHero title="Account Management" />
      <Typography variant="h5" gutterBottom>
        Feature Toggles
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <AccToggleUI
        toggles={toggles}
        handleToggle={handleToggle}
        formatLabel={formatLabel}
      />
    </Box>
  );
};

export default AccountToggles;
